import { render, staticRenderFns } from "./todayDate.vue?vue&type=template&id=ade4ff38"
import script from "./todayDate.vue?vue&type=script&lang=js"
export * from "./todayDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports